<template>
	<div class="container" :style="{width:avatarSize+'px',height:avatarSize+'px',borderRadius:avatarSize+'px',fontSize:size/4+'px', lineHeight:size/4*1.2+'px'}">
		<div ref="containerSquare" v-if="shape==='square'" class="containerSquare avatar-wrap-item" v-bind:class="['avatar-'+writerType]"
			:style="{width:size+'px',height:size+'px',borderRadius: size*0.1+'px'}" @click="triggerClick">
			<div v-if="writer.writer_first_name" class="avatar-text">
				{{writer.writer_first_name}}
			</div>
			<div v-if="writer.writer_last_name" class="avatar-text">
				{{writer.writer_last_name}}
			</div>
		</div>
		<div v-else class="" style="position: relative;display: flex;flex-direction: column;align-items: center;justify-content: center">
			<div v-for="(item, index) in avatarCount" ref="containerCircle" class="containerCircle avatar-wrap-item" v-bind:class="['avatar-'+writerType, ' z-wrap-' + (avatarCount-index)]"
				:style="{width:avatarSize+'px',height:avatarSize+'px',borderRadius:avatarSize+'px'}" @click="triggerClick">
				<div v-if="writer.writer_first_name" class="avatar-text">
					{{writer.writer_first_name}}
				</div>
				<div v-if="writer.writer_last_name" class="avatar-text" style="margin-top: 3px;">
					{{writer.writer_last_name}}
				</div>
			</div>
		</div>
	</div>

</template>
<script>
	export default {
		name: 'WriterAvatar',
		props: {
			shape: {
				type: String,
				validator: function(value) {
					return ['circle', 'square'].indexOf(value) !== -1
				},
				default: 'circle'
			},
			size: {
				type: Number,
				default: 100
			},
			fontSize: {
				type: Number,
				default: 32
			},
			writer: {
				type: Object,
				default: null
			},
			count: {
				type: Number,
				default: 1
			}
		},
		data() {
			return {
				containerWidth: 0,
				scale: 1,
				childrenWidth: 0,
				isSlotShow: false
			};
		},
		computed: {
			avatarSize(){
				return this.size
			},
			avatarCount(){
				return this.count>1?4:1
			},
			writerType() {
				if (this.writer.writer_type === 0) {
					return 'ershou'
				} else if (this.writer.writer_type === 1) {
					if (this.writer.writer_price <= 20) {
						return 'dijia'
					} else {
						return 'zijian'
					}

				} else if (this.writer.writer_type === 2) {
					return 'cankao'
				}
			},
			fontSizeValue() {
				let fontSize = Math.min(this.calcFontSize(this.writer.writer_first_name), this.calcFontSize(this.writer
					.writer_last_name))
				return 14
			}
		},
		methods: {
			triggerClick(e) {
				  //触发first事件
				  this.$emit("click", e);
			},
			calcLineRate() {
				let rate = 0
				rate += this.writer.writer_first_name ? 0.15 : 0
				rate += this.writer.writer_last_name ? 0.35 : 0
				return rate
			},
			calcFontSize(text) {
				const length = Math.round(this.textLength(text) / 2) + this.calcLineRate(); // 获取文本字数

				if (length <= 0) {
					return 100
				}
				const containerWidth = this.$data.containerWidth;
				let fontSize = containerWidth / length * 0.8;
				if (fontSize < 10) {
					return 10;
				} else {
					return fontSize;
				}
			},
			textLength(text) {
				let length = 0;
				for (let i = 0; i < text.length; i++) {
					const char = text[i];
					if (char.charCodeAt(0) > 255) {
						length += 2; // 中文字符长度为2
					} else {
						length += 1; // 其他字符长度为1
					}
				}
				return length
			}
		},
		mounted() {
      this.$nextTick(() => {
        const containerWidth = this.shape==='square'?this.$refs.containerSquare.offsetWidth:this.$refs.containerCircle.offsetWidth; // 获取容器宽度
        this.$data.containerWidth = parseFloat(containerWidth); // parseFloat 是为了去掉单位 px
      });
		},
		updated() {}
	};
</script>
<style scoped>
	.container{
		font-size: 12px;
	}
	.avatar-wrap-item {

		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		border-radius: 4px;
	}
  .avatar-border{
    border: 1px solid #fff;
  }
	.z-wrap-4{
		top: -9px;
		right: 0;
		position: absolute;
    border: 1px solid #fff;
	}
	.z-wrap-3{
		top: -6px;
		right: 0;
		position: absolute;
    border: 1px solid #fff;
	}
	.z-wrap-2{
		top: -3px;
		right: 0;
		position: absolute;
    border: 1px solid #fff;
	}
	.z-wrap-1{
		top: 0;
		right: 0;
		position: relative;
	}
	.avatar-text {
		width: 100%;
		font-weight: bold;
		color: #FFF;
		text-align: center;
		vertical-align: middle;
	}

	.avatar-zijian {
		background-color: #FB5562;
	}

	.avatar-ershou {
		background-color: #40B5F7;
	}

	.avatar-dijia {
		background-color: #40B5F7;
	}

	.avatar-cankao {
		background-color: #E39E35;
	}
</style>
